<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.text}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">{{data.btnNo}}</button>
  <button mat-raised-button color="primary" (click)="onConfirm()" cdkFocusInitial>{{data.btnYes}}</button>
</div>